import { api, crud, downloadAdminBlobGet } from "./api";

export const tahkimMerkez = {
    list: (params) => crud.list("tahkim-dosyalari", params),
    retrieve: (id) => crud.retrieve("tahkim-dosyalari", id),
    update: (id, payload) => crud.update("tahkim-dosyalari", id, payload),
    ozet: () => api.get("/v1/admin/tahkim-dosyalari/ozet/").then((r) => r.data),
    kanban: (params) =>
        api.get("/v1/admin/tahkim-dosyalari/kanban/", { params }).then((r) => r.data),
    saglik: () => api.get("/v1/admin/tahkim-dosyalari/saglik/").then((r) => r.data),
    backfill: () =>
        api.post("/v1/admin/tahkim-dosyalari/backfill/").then((r) => r.data),
    topluGuncelle: (payload) =>
        api.post("/v1/admin/tahkim-dosyalari/toplu-guncelle/", payload).then((r) => r.data),
    asamaGuncelle: (id, payload) =>
        api
            .post(`/v1/admin/tahkim-dosyalari/${id}/asama-guncelle/`, payload)
            .then((r) => r.data),
    dosyaDurumdanAsama: (id) =>
        api
            .post(`/v1/admin/tahkim-dosyalari/${id}/alt-durumdan-asama/`)
            .then((r) => r.data),
    kapanisKontrol: (id, payload) =>
        api
            .post(`/v1/admin/tahkim-dosyalari/${id}/kapanis-kontrol/`, payload || {})
            .then((r) => r.data),
    kapanisGet: (id) =>
        api.get(`/v1/admin/tahkim-dosyalari/${id}/kapanis-kontrol/`).then((r) => r.data),
    islemLoglari: (id) =>
        api.get(`/v1/admin/tahkim-dosyalari/${id}/islem-loglari/`).then((r) => r.data),
    raporSirket: () =>
        api.get("/v1/admin/tahkim-dosyalari/rapor-sirket/").then((r) => r.data),
    exportCsv: (params) =>
        downloadAdminBlobGet(
            "/v1/admin/tahkim-dosyalari/export-csv/",
            "tahkim-dosyalari.csv",
            params || {},
            60000
        ),
    raporTurleri: () =>
        api.get("/v1/admin/tahkim-dosyalari/rapor-turleri/").then((r) => r.data),
    exportRaporPdf: (params) => {
        const tur = params?.tur || "tam";
        return downloadAdminBlobGet(
            "/v1/admin/tahkim-dosyalari/export-rapor-pdf/",
            `tahkim-rapor-${tur}.pdf`,
            params || {},
            180000
        );
    },
    pdfUrl: (id) => `/v1/admin/tahkim-dosyalari/${id}/pdf_rapor/`,

    onTahkimOzet: () =>
        api.get("/v1/admin/tahkim-dosyalari/on-tahkim-ozet/").then((r) => r.data),
    onTahkimBekleyenler: (params) =>
        api.get("/v1/admin/tahkim-dosyalari/on-tahkim-bekleyenler/", { params }).then((r) => r.data),
    onTahkimTara: (payload) =>
        api.post("/v1/admin/tahkim-dosyalari/on-tahkim-tara/", payload || {}).then((r) => r.data),
    onTahkimBackfill: () =>
        api.post("/v1/admin/tahkim-dosyalari/on-tahkim-backfill/").then((r) => r.data),
    onTahkimBaslat: (payload) =>
        api.post("/v1/admin/tahkim-dosyalari/on-tahkim-baslat/", payload).then((r) => r.data),
    onTahkimUygula: (payload) =>
        api.post("/v1/admin/tahkim-dosyalari/on-tahkim-uygula/", payload).then((r) => r.data),
    onTahkimGecisModu: (payload) =>
        api.post("/v1/admin/tahkim-dosyalari/on-tahkim-gecis-modu/", payload).then((r) => r.data),
    onTahkimPano: (params) =>
        api.get("/v1/admin/tahkim-dosyalari/on-tahkim-pano/", { params }).then((r) => r.data),
};


export const TAHKIM_ASAMALARI = [
    { value: "ON_TAHKIM", label: "Ön Tahkim" },
    { value: "BASVURU", label: "Başvuru Yapıldı" },
    { value: "HAKEM", label: "Hakem Atandı" },
    { value: "BILIRKISI", label: "Bilirkişi" },
    { value: "ARA_KARAR", label: "Ara Karar" },
    { value: "KARAR", label: "Karar" },
    { value: "ODEME", label: "Ödeme Bekleniyor" },
    { value: "KAPANDI", label: "Kapandı" },
];

export const ODEME_DURUMLARI = [
    { value: "BEKLIYOR", label: "Bekliyor" },
    { value: "ODENDI", label: "Ödendi" },
    { value: "GECIKTI", label: "Gecikti" },
    { value: "IPTAL", label: "İptal" },
];
